<template>
  <div class="dashboard background">
    <dashboard-page pcontent="1" page="DASHBOARD"
      class="fCol jStart aCenter">
      <btn
      v-if="false"
      label="ورود به سایت"
      icon="clear"/>
      <div class="dashboardHolder fullWidth fCol jStart aCenter">
        <div class="chart fullWidth" style="position: relative">
          <chart-sale />
        </div>
        <div class="chart fullWidth" style="position: relative">
          <chart-bar />
        </div>
        <div class="dashboardHeader fullWidth fCol jStart aCenter" v-if="false">
          <div class="rimikTypo"></div>
          <div class="fCol jCenter aCenter growFull">
            <!-- <h2>داشبورد ریمیک</h2> -->
            <p>خلاصه آمار و اطلاعات سیستم ریمیک</p>
          </div>
        </div>
        <!-- fullWidth Card - line Chart -->
        <div class="fullWidth fRow jAround aCenter card color7">
          <div class="growFull fRow jCenter aCenter">
            <i class="material-icons-round cardIcon">assignment</i>
            <div class="fCol growFull jCenter aStart">
              <label class="title fullWidth">تعداد کل تفاهم نامه‌ها</label>
              <div class="mainValue">
                <!-- eslint-disable-next-line -->
                {{commaSep(statics.numberOfAllActiveAssignment + statics.numberOfAllDeActiveAssignment)}}
                <div class="unit">تفاهم نامه‌ی ثبت شده</div>
              </div>
            </div>
          </div>
          <div class="chart w33" style="position: relative">
            <chart-doughnut :data="assignmentData" />
          </div>
        </div>
        <!-- fullWidth Card - line Chart -->
        <div class="fullWidth fRow jAround aCenter card color3">
          <div class="w50 fRow jCenter aCenter">
            <i class="material-icons-round cardIcon">assignment</i>
            <div class="fCol growFull jCenter aStart">
              <label class="title fullWidth">تعداد آیتم</label>
              <div class="mainValue">{{commaSep(2560)}} <div class="unit">واحد</div></div>
            </div>
          </div>
          <div class="chart w50" style="position: relative">
            <chart-line />
          </div>
        </div>
        <!-- تفاهم نامه ها -->
        <div class="fullWidth fRow jAround aCenter infoBlock">
          <div class="bigItem ww50 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">assignment</i>
            <div class="bigTitle">
              آمار تفاهم نامه‌ها
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfAllActiveAssignment + statics.numberOfAllDeActiveAssignment)}}
              <div class="bigUnit">تفاهم نامه‌ی ثبت شده</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/assignment')">
              <i class="material-icons-round">assignment</i>
              <label>مدیریت تفاهم نامه‌ها</label>
            </div>
          </div>
          <div class="ww50 fCol jCenter aStart">
            <!-- تفاهم نامه های فعال -->
            <div class="fRow jStart aCenter item fullWidth" style="margin-bottom: 16px">
              <i class="material-icons-round infoIcon">assignment</i>
              <div class="growFull fCol jCenter aStart">
                <div class="infoTitle fullWidth">تعداد تفاهم نامه‌های فعال</div>
                <div class="today">
                  {{commaSep(statics.numberOfTodayActiveAssignment)}} مورد برای امروز</div>
              </div>
              <div class="value fCol jCenter aStart">
                {{commaSep(statics.numberOfAllActiveAssignment)}}
                <div class="unit">تفاهم‌نامه</div>
              </div>
            </div>
            <!-- تفاهم نامه های غیرفعال -->
            <div class="fRow jStart aCenter item fullWidth">
              <i class="material-icons-round infoIcon">assignment</i>
              <div class="growFull fCol jCenter aStart">
                <div class="infoTitle fullWidth">تعداد تفاهم نامه‌های غیرفعال</div>
                <div class="today">
                  {{commaSep(statics.numberOfTodayDeActiveAssignment)}} مورد برای امروز</div>
              </div>
              <div class="value fCol jCenter aStart">
                {{commaSep(statics.numberOfAllDeActiveAssignment)}}
                <div class="unit">تفاهم‌نامه</div>
              </div>
            </div>
          </div>
        </div>
        <!-- مشاورین -->
        <div class="fullWidth fRow jAround aCenter infoBlock">
          <div class="bigItem ww33 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">auto_stories</i>
            <div class="bigTitle">
              تعداد مشاورین آموزشی
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfEducationalConsultants)}}
              <div class="bigUnit">مشاور آموزشی</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/assignment')">
              <i class="material-icons-round">support_agent</i>
              <label>مدیریت مشاورین</label>
            </div>
          </div>
          <div class="bigItem ww33 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">school</i>
            <div class="bigTitle">
              تعداد اساتید
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfTeacher)}}
              <div class="bigUnit">استاد</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/teachers')">
              <i class="material-icons-round">school</i>
              <label>مدیریت اساتید</label>
            </div>
          </div>
          <div class="bigItem ww33 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">support_agent</i>
            <div class="bigTitle">
              تعداد مشاورین جذب
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfAbsorptionConsultants)}}
              <div class="bigUnit">مشاور جذب</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/assignment')">
              <i class="material-icons-round">support_agent</i>
              <label>مدیریت مشاورین</label>
            </div>
          </div>
        </div>
        <!-- آزمون ها -->
        <div class="fullWidth fRow jBetween aCenter infoBlock">
          <div class="bigItem ww33 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">question_mark</i>
            <div class="bigTitle">
              تعداد آزمون‌های ثبت شده
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfExam)}}
              <div class="bigUnit">آزمون ثبت شده</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/exams')">
              <i class="material-icons-round">question_mark</i>
              <label>مدیریت آزمون‌ها</label>
            </div>
          </div>
          <div class="bigItem ww33 item fCol jCenter aCenter">
            <i class="material-icons-round bigIcon">checklist_rtl</i>
            <div class="bigTitle">
              تعداد پاسخ نامه‌ها
            </div>
            <div class="bigValue">
              <!-- eslint-disable-next-line -->
              {{commaSep(statics.numberOfAnswerSheet)}}
              <div class="bigUnit">پاسخ نامه</div>
            </div>
            <div class="b fRow jCenter aCenter" @click="go('/exams')">
              <i class="material-icons-round">question_mark</i>
              <label>مدیریت آزمون‌ها</label>
            </div>
          </div>
          <div class="chart ww66">chart</div>
        </div>
      </div>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
  </div>
</template>

<script>
import axios from 'axios';
import makeToast from '@/mixins/makeToast';
import errorHandler from '@/mixins/mixin';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Btn from '@/components/Btn.vue';
import ChartSale from '@/components/dashboard/ChartExample.vue';
import ChartBar from '@/components/dashboard/ChartBarExample.vue';
import ChartLine from '@/components/dashboard/ChartLine.vue';
import ChartDoughnut from '@/components/dashboard/ChartDoughnut.vue';

export default {
  mixins: [makeToast, errorHandler],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      statics: {
      },
    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    initUserData() {
      // این اول صفحه اجرا میشه
      if (this.$store.state.fp === 'undefined') {
        this.fpGenerator().then(() => {
          this.$authObeject.checkDate().then((result) => {
            if (result) {
              // console.log('توکن منقضی شده، درخواست ریفرش توکن');
            } else {
              this.initPage();
            }
          });
        });
      } else {
        this.initPage();
      }
    },
    initPage() {
      // اینیت اولیه پیج
    },
    getStatics() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Statics/count`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.statics = response.data.data;
          this.$store.commit('setLoadingOff');
        } else {
          this.makeToast('error', response.data.message, 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      }).catch(() => {
        this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
      });
    },
    commaSep(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    go(r) {
      this.$router.push(`${r}`);
    },
  },
  computed: {
    assignmentData() {
      return {
        active: this.statics.numberOfAllActiveAssignment,
        deactive: this.statics.numberOfAllDeActiveAssignment,
      };
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Btn,
    ChartSale,
    ChartBar,
    ChartLine,
    ChartDoughnut,
  },
  mounted() {
    this.getStatics();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
.dashboardHolder {
  max-width: 850px;
  .dashboardHeader {
    padding-top: 32px;
    padding-bottom: 64px;
    .rimikTypo {
      width: 168px;
      height: 88px;
      min-width: 88px;
      margin-bottom: 16px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('~@/assets/rimikdark.svg');
    }
    h2 {
      padding: 0;
      font-size: 32px;
      font-weight: bold;
    }
    p {
      padding: 0;
      margin: 0;
      font-size: 20px;
      font-weight: 100;
    }
  }
  .infoBlock {
    margin-bottom: 32px;
    padding: 16px;
    border-radius: 16px;
    border: solid 2px var(--normalText05);
    .b {
      margin-top: 16px;
    }
    .item {
      padding: 16px;
      border-radius: 16px;
      box-shadow: 0px 24px 32px -12px var(--themeBlack25),
        inset 0 32px 64px -16px rgba($color: $color3, $alpha: 0.25);
      .value {
        font-size: 48px;
        font-weight: 100;
        padding: 8px 16px;
        color: white;
        line-height: 1;
        background-color: $color3;
        margin-left: -32px;
        border-radius: 8px;
        box-shadow: -16px 0px 24px -8px rgba($color: $color10, $alpha: 0.5);
        .unit {
          font-size: 10px;
          color: white;
        }
      }
      .infoTitle {
        text-align: right;
        font-size: 16px;
        line-height: 1.2;
        font-weight: bold;
      }
      .today {
        padding: 4px 8px;
        line-height: 1;
        font-size: 12px;
        border-radius: 16px;
        margin-top: 4px;
        background-color: rgba($color: $primary, $alpha: 1);
        color: white;
      }
      .infoIcon {
        font-size: 40px;
        margin-left: 8px;
      }
    }
    .bigItem {
      position: relative;
      min-height: 228px;
      overflow: hidden;
      i.bigIcon {
        font-size: 280px;
        position: absolute;
        left: -64px;
        top: 50%;
        transform: translateY(-50%) rotate(15deg);
        opacity: 0.05;
        pointer-events: none;
      }
      .bigTitle {
        font-size: 14px;
        font-weight: bold;
        color: $normalText;
        margin-bottom: 8px;
        border-bottom-left-radius: 24px;
        border-bottom-right-radius: 24px;
        padding: 0 24px 4px 24px;
        border-bottom: dashed 1px rgba($color: $primary, $alpha: 0.35);
        box-shadow: 0 12px 16px -12px rgba($color: #000000, $alpha: 1.0);
      }
      .bigValue {
        font-size: 60px;
        font-weight: 100;
        color: $normalText;
        text-shadow: 0 8px 16px rgba($color: #000000, $alpha: 0.15);
        line-height: 1;
        .bigUnit {
          font-size: 12px;
          font-weight: 100;
          color: $primary;
        }
      }
      .bogToday {
        padding: 8px 16px;
        line-height: 1;
        font-size: 16px;
        border-radius: 16px;
        margin-top: 4px;
        background-color: rgba($color: $primary, $alpha: 1);
        color: white;
      }
    }
  }
  .card {
    border-radius: 24px;
    box-shadow: 0 16px 24px -8px rgba($color: #000000, $alpha: 0.15);
    padding: 16px;
    margin-bottom: 16px;
    position: relative;
    .cardIcon {
      font-size: 48px;
      margin-left: 16px;
      padding: 24px;
      border-radius: 35%;
      margin-right: -68px;
      box-shadow: 0 16px 16px -8px rgba($color: #000000, $alpha: 0.65),
        inset 0 -24px 64px -24px rgba($color: #000000, $alpha: 0.45);
      background-color: $color2;
      z-index: 10;
    }
    label.title {
      font-weight: 100;
      color: $invertText;
      font-size: 14px;
      text-align: right;
      line-height: 1;
      margin-bottom: 8px;
      z-index: 10;
    }
    .mainValue {
      font-weight: bold;
      font-size: 36px;
      text-shadow: 0 2px 0 var(--themeBlack25);
      color: $invertText;
      line-height: 1;
      padding: 0 0 8px 8px;
      border-bottom: 1px solid rgba($color: $invertText, $alpha: 0.25);
      z-index: 10;
      .unit {
        font-size: 12px;
        font-weight: 200;
        color: $invertText;
        display: inline;
        text-shadow: none;
      }
    }
  }
  // CUSTOM
  .ww33 {
    width: calc(33.3333% - 32px);
  }
  .ww25 {
    width: calc(25% - 32px);
  }
  .ww20 {
    width: calc(20% - 32px);
  }
  .ww50 {
    width: calc(50% - 32px);
  }
  .ww66 {
    width: calc(66.66% - 32px);
  }
  .ww60 {
    width: calc(60% - 32px);
  }
  .ww75 {
    width: calc(75% - 32px);
  }
  .ww80 {
    width: calc(80% - 32px);
  }
}
</style>
